module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-7 col-sm-7"
  }, [_c('div', {
    staticClass: "prod-container product"
  }, [_c('img', {
    staticClass: "prod-img",
    attrs: {
      "src": _vm.getProductImage(_vm.product)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "prod-replica"
  }, [_c('div', {
    staticClass: "prod-replica-table"
  }, [_c('div', {
    staticClass: "prod-replica-table-td",
    class: _vm.product.ui_classes
  }, _vm._l((_vm.product.max_lines), function(n) {
    return _c('p', [_vm._v(_vm._s(_vm.lines[n - 1]))])
  }))])]), _vm._v(" "), _c('p', {
    staticClass: "product-description"
  }, [_vm._v("\n                * Shown using Frutiger font & " + _vm._s(_vm.product.max_characters) + " characters per line.\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5 col-sm-5"
  }, [_c('h3', {
    staticClass: "product-size",
    domProps: {
      "innerHTML": _vm._s(_vm.product.description)
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "product-price"
  }, [_vm._v(_vm._s(_vm.product.material))]), _vm._v(" "), _c('h3', {
    staticClass: "product-inscription"
  }, [_vm._v("INSCRIPTION")]), _vm._v(" "), _c('div', {
    staticClass: "brick-text-form"
  }, _vm._l((_vm.product.max_lines), function(n) {
    return _c('div', {
      staticClass: "form-group row no-gutter"
    }, [_c('div', {
      staticClass: "col-md-2"
    }, [_c('label', {
      attrs: {
        "for": 'l-' + n
      }
    }, [_vm._v("Line " + _vm._s(n) + ":")])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-10"
    }, [_c('input', {
      staticClass: "form-control",
      attrs: {
        "line-id": 'l-' + n,
        "id": 'l-' + n,
        "maxlength": _vm.product.max_characters,
        "size": _vm.product.max_characters
      },
      domProps: {
        "value": _vm.lines[n - 1]
      },
      on: {
        "keydown": function($event) {
          _vm.withAnyKeyDown($event)
        },
        "keyup": function($event) {
          _vm.withAnyKeyUp($event)
        },
        "input": function($event) {
          _vm.withInput($event)
        }
      }
    })])])
  })), _vm._v(" "), _c('p', {
    staticClass: "product-description"
  }, [_vm._v("Need inspiration?\n            "), _c('a', {
    staticClass: "text-danger pointer",
    on: {
      "click": function($event) {
        _vm.showInscriptionExamples()
      }
    }
  }, [_vm._v("Click here")]), _vm._v("\n            for inscription examples.\n        ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3950c8a8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/virtual/Brick.vue
// module id = k5Zn
// module chunks = 1